import React from 'react';
import withStaticBuilder from 'StaticBuilder/hocs/StaticBuilderField';
import PropTypes from 'prop-types';

const SelectList = props => (
  <select
    id={props.id}
    name={props.id}
    onChange={props.onChange}
    value={props.value}
  >
    {
      props.options.map(option => (
        <option key={`${props.id}_${option.value}`} value={option.value}>
          {option.text}
        </option>
      ))
    }

  </select>
);

SelectList.defaultProps = {
  value: '',
};

SelectList.propTypes = {
  id: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string,
      value: PropTypes.string,
    }),
  ).isRequired,
  value: PropTypes.string,
};

export default withStaticBuilder(SelectList);



// WEBPACK FOOTER //
// ./src-react/StaticBuilder/SelectList.jsx